const get = require('lodash/get')
const { getByIds: getLocationsByIds } = require('../../../location')
const { getProductAliasMasterData } = require('../master-data')
const { list: listFunders } = require('./../../../funders')
const { list: listRoutes } = require('./../../../routes')
const tools = require('../../tools')
const { time, log } = require('../../tools/logging')

// Decorate an order doc we already hold into the REST-shaped entity without reading
// it again. `getSuborder` uses this after a read; `updateSuborder` uses it with the
// doc it just wrote, because a post-write re-read is a Mango `_find` (not a quorum
// read on the clustered `order` db) and can come back with the pre-write revision.
exports.decorateSuborder = decorateSuborder
async function decorateSuborder (state, doc, {alias = 'one', date = new Date().toJSON(), useGenericParent = false, logging = false} = {}) {
  const locationIds = [doc.destinationId, doc.supplierId]

  const locationEntities = await getLocationsByIds(state, locationIds, date)

  const warehouseCodeMap = locationIds
    .reduce((acc, locationId, index) => {
      const locationEntity = locationEntities.find(location => location._id === locationId) || {}
      acc[locationId] = get(locationEntity, 'additionalData.warehouseCode')
      return acc
    }, {})

  const timeMasterData = time()
  const batches = Object.values(doc.products).flatMap(product => Object.keys(product.batches || {}))
  const productMasterData = await getProductAliasMasterData(state, {productIds: Object.keys(doc.products), batches})
  const funders = await listFunders(state)
  const routes = await listRoutes(state)
  log('got order master data', logging, timeMasterData)

  return tools.getSuborder({doc, alias, warehouseCodeMap, funders, routes, productMasterData, useGenericParent})
}
